export enum FormCheckboxTypes {
  CHECKBOX = "checkbox",
  RADIO = "radio",
}
